import _toConsumableArray from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import PropTypes from 'prop-types';
import React from 'react';
import { withEnums } from '../../../decorators';
import Dropdown from './Dropdown';

function LegalStructureDropdown(_ref) {
  var isClearable = _ref.isClearable,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      legalStructures = _ref.legalStructures,
      regionName = _ref.regionName,
      classNamePrefix = _ref.classNamePrefix;
  var regionLegalStructures = legalStructures && legalStructures[regionName];

  if (!regionLegalStructures) {
    return null;
  }

  var extendedRegionLegalStructures = [].concat(_toConsumableArray(regionLegalStructures), [{
    title: 'Other'
  }]);
  var availableOptions = extendedRegionLegalStructures.map(function (structure) {
    return {
      label: structure.title,
      value: structure.title
    };
  });
  return React.createElement(Dropdown, {
    isClearable: isClearable,
    placeholder: placeholder,
    options: availableOptions,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    classNamePrefix: classNamePrefix
  });
}

LegalStructureDropdown.propTypes = {
  isClearable: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  regionName: PropTypes.string.isRequired,
  legalStructures: PropTypes.object,
  classNamePrefix: PropTypes.string
};
LegalStructureDropdown.defaultProps = {
  isClearable: false,
  placeholder: 'Legal Structure',
  classNamePrefix: 'SearchableDropdown'
};
export default withEnums('legalStructures')(LegalStructureDropdown);